import React, { useEffect } from 'react';

interface GmailComposePopupProps {
  email: string;
  onClose: () => void;
  subject?: string;
  template?: string;
}

export default function GmailComposePopup({ 
  email, 
  onClose,
  subject = '', // Optional default subject
  template = `

Best regards,
[Your Name]
[Your Title]
`, // Default signature template
}: GmailComposePopupProps) {
  useEffect(() => {
    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1` +
      `&to=${encodeURIComponent(email)}` +
      `&su=${encodeURIComponent(subject)}` +
      `&body=${encodeURIComponent(template)}`;
    
    // Open Gmail in a new window with specific dimensions
    const gmailWindow = window.open(
      gmailUrl,
      'GmailCompose',
      'width=800,height=600,left=200,top=200'
    );

    // Close the popup component once Gmail is opened
    onClose();

    // Cleanup
    return () => {
      if (gmailWindow) {
        // Note: We can't force close the window due to browser security restrictions
        // The user will need to close it manually
      }
    };
  }, [email, onClose, subject, template]);

  // We don't need to render anything since we're opening a new window
  return null;
} 